import { useLanguage } from '../i18n/LanguageContext';
import WhatsAppIcon from './WhatsAppIcon';

const WhatsAppButton = () => {
    const { language } = useLanguage();
    const labels = { fr: 'WhatsApp', en: 'WhatsApp', es: 'WhatsApp' };

    return (
        <a
            href="https://wa.me/971503580724"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label={`${labels[language]} +971 50 358 0724`}
        >
            <WhatsAppIcon className="h-5 w-5" />
            <span className="hidden sm:inline">{labels[language]}</span>
        </a>
    );
};

export default WhatsAppButton;
